export default __webpack_public_path__ + "static/media/ybvr-thumbnail.76823127.png";